import React, { useEffect } from 'react';
import { Button, Form, Input, Spin, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import TagInput from '../Elements/TagInput';
const RiderForm = ({ handleSubmit, action, rider, handleCancel, isFetching }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('drivers');
  const { t: tc } = useTranslation('common');

  const [skills, setSkills] = React.useState([]);

  const setParams = (values) => {
    const params = { ...values, skills };
    return params;
  };
  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(setParams(values));
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue({ name: null, email: null, phone: '+41' });
    } else if (rider) {
      // OVO-207 — pre-fill the "Admin access" toggle from the driver's linked
      // account roles (API returns the Prisma enum value, e.g. "ADMIN").
      const hasAdmin = (rider.user?.roles || rider.roles || []).some((r) => String(r).toUpperCase() === 'ADMIN');
      form.setFieldsValue({
        ...rider,
        isAdmin: hasAdmin,
      });
      setSkills(rider.skills || []);
    }
  }, [action, rider]);

  return (
    <Spin spinning={isFetching}>
      <div className="RiderForm">
        <div className="FormHeader"></div>
        <div className="FormContent">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            requiredMark={false}
            colon={false}
            onFinish={onFinishForm}
          >
            <Form.Item
              label={t('email')}
              name="email"
              rules={[
                { required: true, message: tc('required') },
                { type: 'email', message: tc('invalidEmail') },
              ]}
            >
              <Input placeholder={t('email')} />
            </Form.Item>
            <Form.Item
              label={t('password')}
              name="password"
              // OVO-207 — password is optional: when the email belongs to an
              // existing user (e.g. an admin who also drives), the backend
              // LINKS a driver profile to that account (no password needed).
              // A brand-new driver still needs one, enforced server-side.
              extra={action === 'new' ? t('passwordLinkHint') : undefined}
              rules={[{ required: action !== 'new' && !rider?.email, message: tc('required') }]}
            >
              <Input.Password placeholder={t('password')} autoComplete="new-password" />
            </Form.Item>
            <Form.Item label={t('name')} name="name" rules={[{ required: true, message: tc('required') }]}>
              <Input placeholder={t('name')} />
            </Form.Item>
            <Form.Item label={t('phoneNumber')} name="phone">
              <PhoneInput
                country={'ch'}
                prefix="+"
                specialLabel=""
                countryCodeEditable
                enableSearch
                disableSearchIcon
              />
            </Form.Item>
            <Form.Item label={t('skills')} name="skills">
              <TagInput tags={skills} onChange={(values) => setSkills(values)} />
            </Form.Item>
            {/* OVO-207 — promote/demote a driver to also hold the ADMIN role
                (multi-role). Edit-mode only: a brand-new driver is created as
                a driver; granting admin to an existing admin is done from the
                create form by entering their email. */}
            {action !== 'new' && (
              <Form.Item label={t('adminAccess')} name="isAdmin" valuePropName="checked" extra={t('adminAccessHint')}>
                <Switch />
              </Form.Item>
            )}
          </Form>
        </div>
        <div className="FormFooter">
          <Button key="cancel" onClick={handleCancel}>
            {tc('cancel')}
          </Button>
          <Button type="primary" block size="large" onClick={() => form.submit()}>
            {action === 'new' ? tc('create') : tc('update')}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default RiderForm;
